import styled, { css } from 'styled-components';
import { SYS_BORDER_RADIUS_SM } from '@oneaudi/unified-web-common';
import { ComponentContainer, ComponentsContainer, Row } from './NumbersMode.style';
import { Alignment, TextComponentContainerProps } from '../../types';

export const TextRow = styled(Row)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-wrap: wrap;
  }
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    flex-wrap: nowrap;
    &:not(:last-child) {
      margin-block-end: 1px;
    }
  }
`;

export const TextComponentsContainer = styled(ComponentsContainer)`
  /* Apply rounded corners only to corner elements */
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    /* Top-left corner: first row, first child */
    ${Row}:first-child ${ComponentContainer}:first-child {
      border-top-left-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Top-right corner: first row, last child */
    ${Row}:first-child ${ComponentContainer}:last-child {
      border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Bottom-left corner: last row, first child */
    ${Row}:last-child ${ComponentContainer}:first-child {
      border-bottom-left-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Bottom-right corner: last row, last child */
    ${Row}:last-child ${ComponentContainer}:last-child {
      border-bottom-right-radius: ${SYS_BORDER_RADIUS_SM};
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) and (max-width: ${({
      theme,
    }) => theme.breakpoints.lg - 1}px) {
    ${Row} ${ComponentContainer}:nth-child(3) {
      border-top: 1px solid ${({ theme }) => theme.colors.divider};
    }
    ${Row}:first-child ${ComponentContainer}:nth-child(2n) {
      border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
    }
    /* Top-right corner: first row, last child */
    ${Row}:first-child ${ComponentContainer}:last-child {
      border-top-right-radius: 0;
      &:nth-child(2) {
        border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
      }
    }
    ${Row}:first-child:last-child ${ComponentContainer}:first-child:last-child {
      border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
    }
    /* container is having exact 2 children: last row, first child */
    ${Row}:last-child:has(> :nth-child(2)):has(> :last-child:nth-child(2)) ${ComponentContainer}:first-child {
      border-bottom-left-radius: ${SYS_BORDER_RADIUS_SM};
    }
    /* Bottom-left corner: last row, first child */
    ${Row}:last-child ${ComponentContainer}:first-child {
      border-bottom-left-radius: 0;
    }
    /* Bottom-right corner: last row, last child */
    ${Row}:last-child ${ComponentContainer}:last-child {
      border-bottom-left-radius: ${SYS_BORDER_RADIUS_SM};
      &:nth-child(2) {
        border-bottom-left-radius: 0;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md - 1}px) {
    /* Mobile: first element gets top corners */
    ${Row}:first-child ${ComponentContainer}:first-child {
      border-top-left-radius: ${SYS_BORDER_RADIUS_SM};
      border-top-right-radius: ${SYS_BORDER_RADIUS_SM};
    }

    /* Mobile: last element gets bottom corners */
    ${Row}:last-child ${ComponentContainer}:last-child {
      border-bottom-left-radius: ${SYS_BORDER_RADIUS_SM};
      border-bottom-right-radius: ${SYS_BORDER_RADIUS_SM};
    }
  }
`;

export const TextComponentContainer = styled(ComponentContainer)<TextComponentContainerProps>`
  flex-grow: 1;
  ${({ textAlignment }) =>
    textAlignment === Alignment.CENTER
      ? css`
          align-items: center;
          text-align: center;
        `
      : css`
          align-items: flex-start;
          text-align: left;
        `};
`;
